import React, { useEffect } from "react";
import { getOktaUserInfo, manageUserData } from "../service/api";
import { manageUserPayload } from '../../src/Utils/utils';

function Login3(props) {
    const esgToken = getParameterByName1("id_token");
    const oktaAccessToken = getParameterByName("access_token");
    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }
      function getParameterByName1(name, url = window.location.href) {
          name = name.replace(/[[\]]/g, '\\$&');
          var regex = new RegExp('[#&]' + name + '(=([^&#]*)|&|#|$)'),
              results = regex.exec(url);
          if (!results) return null;
          if (!results[2]) return '';
          return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }

  useEffect(() => {
    setToken();
  }, []);

  async function setToken() {
    localStorage.clear();
    localStorage.setItem("ESGToken",esgToken);
    localStorage.setItem("okta_access_token",oktaAccessToken);
    const userInfo = await getOktaUserInfo();
    const userInfoData = userInfo?.data;
    if(userInfoData) {
      const tenant= userInfoData.tenantId ? userInfoData.tenantId : "t001";
      const manageUserPayloadData = manageUserPayload('', userInfoData?.given_name, userInfoData?.family_name, 'Okta', '', tenant, 'Admin', userInfoData?.email, userInfoData?.sAMAccountname, 'NA', 'Active');
      localStorage.setItem("tenantId", tenant);
      localStorage.setItem("dealerName",userInfoData?.name);
      localStorage.setItem("userName",userInfoData?.name);
      localStorage.setItem("email", userInfoData?.email);
      localStorage.setItem("firstName", userInfoData?.given_name);
      localStorage.setItem("lastName", userInfoData?.family_name);
      localStorage.setItem("userId", userInfoData?.sAMAccountname);
      const manageUserDataRes = await manageUserData(manageUserPayloadData);
      const manageUserInfo = manageUserDataRes?.data;
      if (manageUserInfo) {
        localStorage.setItem("userRole", manageUserInfo.userRole);
        props.userRoleUpdate(manageUserInfo.userRole);
        localStorage.setItem("tenantId", manageUserInfo.tenantId);
      }
        props.history.push("/grounded");
    }
   }


  return <div></div>;
}

export default Login3;
